<template>
  <h3 v-if="hasTip" class="text-body-1"
    >Tip : {{ formatUSD(getTipFromCart) }}</h3
  >
</template>

<script>
import { mapGetters } from 'vuex'
import formatUSD from '@/utils/formatUSD'

export default {
  name: 'CartTipLineItem',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters('cart', ['hasTip', 'getTipFromCart']),
  },
  methods: {
    formatUSD,
  },
}
</script>
